import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { NullBody1903zz7riiwr0 as NullBody } from '../../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance2qxbzj50paf3c as Phases_getInstance_0,
} from '../../statement/HttpResponsePipeline.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TransformRequestBodyContextClass;
function TransformRequestBodyContext() {
  if (TransformRequestBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformRequestBodyContext');
    TransformRequestBodyContextClass = $;
  }
  return TransformRequestBodyContextClass;
}
var TransformResponseBodyContextClass;
function TransformResponseBodyContext() {
  if (TransformResponseBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformResponseBodyContext');
    TransformResponseBodyContextClass = $;
  }
  return TransformResponseBodyContextClass;
}
var OnRequestContextClass;
function OnRequestContext() {
  if (OnRequestContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'OnRequestContext');
    OnRequestContextClass = $;
  }
  return OnRequestContextClass;
}
function RequestHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler(new (OnRequestContext())(), $this$intercept.y4s_1, $this$intercept.z4r(), $completion);
    return Unit_instance;
  }, 2);
}
var RequestHookClass;
function RequestHook() {
  if (RequestHookClass === VOID) {
    class $ {
      a5t(client, handler) {
        var tmp = Phases_getInstance().j5m_1;
        client.g5g_1.c4t(tmp, RequestHook$install$slambda(handler));
      }
      n5m(client, handler) {
        return this.a5t(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestHook');
    RequestHookClass = $;
  }
  return RequestHookClass;
}
var RequestHook_instance;
function RequestHook_getInstance() {
  return RequestHook_instance;
}
function TransformRequestBodyHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var newContent = yield* $handler(new (TransformRequestBodyContext())(), $this$intercept.y4s_1, $this$intercept.z4r(), $this$intercept.y4s_1.b5t(), $completion);
    var tmp;
    if (!(newContent == null)) {
      yield* $this$intercept.a4s(newContent, $completion);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 2);
}
var TransformRequestBodyHookClass;
function TransformRequestBodyHook() {
  if (TransformRequestBodyHookClass === VOID) {
    class $ {
      c5t(client, handler) {
        var tmp = Phases_getInstance().k5m_1;
        client.g5g_1.c4t(tmp, TransformRequestBodyHook$install$slambda(handler));
      }
      n5m(client, handler) {
        return this.c5t(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformRequestBodyHook');
    TransformRequestBodyHookClass = $;
  }
  return TransformRequestBodyHookClass;
}
var TransformRequestBodyHook_instance;
function TransformRequestBodyHook_getInstance() {
  return TransformRequestBodyHook_instance;
}
function TransformResponseBodyHook$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var _destruct__k2r9zo = $this$intercept.z4r();
    var typeInfo = _destruct__k2r9zo.ze();
    var content = _destruct__k2r9zo.af();
    var tmp;
    if (!isInterface(content, ByteReadChannel())) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = yield* $handler(new (TransformResponseBodyContext())(), $this$intercept.y4s_1.t5g(), content, typeInfo, $completion);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newContent = tmp_0;
    var tmp_1;
    var tmp_2;
    if (!(newContent instanceof NullBody())) {
      tmp_2 = !typeInfo.q4t_1.cf(newContent);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      throw IllegalStateException().o('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + typeInfo.toString());
    }
    yield* $this$intercept.a4s(new (HttpResponseContainer())(typeInfo, newContent), $completion);
    return Unit_instance;
  }, 2);
}
var TransformResponseBodyHookClass;
function TransformResponseBodyHook() {
  if (TransformResponseBodyHookClass === VOID) {
    class $ {
      d5t(client, handler) {
        var tmp = Phases_getInstance_0().q5h_1;
        client.h5g_1.c4t(tmp, TransformResponseBodyHook$install$slambda(handler));
      }
      n5m(client, handler) {
        return this.d5t(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformResponseBodyHook');
    TransformResponseBodyHookClass = $;
  }
  return TransformResponseBodyHookClass;
}
var TransformResponseBodyHook_instance;
function TransformResponseBodyHook_getInstance() {
  return TransformResponseBodyHook_instance;
}
//region block: init
RequestHook_instance = new (RequestHook())();
TransformRequestBodyHook_instance = new (TransformRequestBodyHook())();
TransformResponseBodyHook_instance = new (TransformResponseBodyHook())();
//endregion
//region block: exports
export {
  RequestHook_instance as RequestHook_instanceaw1sbzrckls9,
  TransformRequestBodyHook_instance as TransformRequestBodyHook_instance3isql5xg2cuq7,
  TransformResponseBodyHook_instance as TransformResponseBodyHook_instance14phngq6mxh8h,
};
//endregion

//# sourceMappingURL=KtorCallContexts.mjs.map
